import React from 'react'
import { v4 as uuidv4 } from 'uuid'
import {
  Skeleton as AvatarSkeleton,
  Skeleton as HighlightSkeleton,
  Skeleton as PopoverButtonSkeleton,
  Skeleton as TextSkeleton,
} from '@node-space/storybook-components/dist/SkeletonLoader'
import { Box } from '@node-space/ui-components'

interface ActionListSkeletonLoaderProps {
  hasPopoverMenu?: boolean
  rows?: number
}

export const ActionListSkeletonLoader = ({
  rows = 5,
  hasPopoverMenu,
}: ActionListSkeletonLoaderProps) => {
  return (
    <>
      {[...Array(rows)]?.map(() => (
        <Box key={uuidv4()} paddingX={16} paddingY={12} flex align="center" gapX={12} hasBorder>
          <AvatarSkeleton variant="button" isIcon />
          <Box flexCol gap={8} flexSize="fill">
            <TextSkeleton className="w-40" variant="text" />
            <TextSkeleton className="w-32" variant="text-xs" />
          </Box>
          <HighlightSkeleton className="w-28 rounded-[20px]" variant="title" />
          {hasPopoverMenu && (
            <Box flex justify="center" className="w-10">
              <PopoverButtonSkeleton className="w-2" variant="button" />
            </Box>
          )}
        </Box>
      ))}
    </>
  )
}
